import { Box, Typography, Checkbox, Divider } from "@mui/material";
import React from "react";

interface FilterCheckboxItemProps {
    option: {
      id: number | string;
      name: string;
    };
    filterKey: string;
    checked: boolean;
    onToggle: (filterKey: string, optionId: number | string, isChecked: boolean) => void;
  }

  const FilterCheckboxItem: React.FC<FilterCheckboxItemProps> = React.memo(
    ({ option, filterKey, checked, onToggle }) => {
      const handleChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
          onToggle(filterKey, option.id, e.target.checked);
        },
        [filterKey, option.id, onToggle]
      );
  
      return (
        <React.Fragment>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              py: 1,
            }}
          >
            <Typography>{option.name}</Typography>
            <Checkbox checked={checked} onChange={handleChange} />
          </Box>
          <Divider component={"hr"} />
        </React.Fragment>
      );
    },
    (prevProps, nextProps) => {
      // Custom comparison function for better memoization
      return (
        prevProps.option.id === nextProps.option.id &&
        prevProps.option.name === nextProps.option.name &&
        prevProps.filterKey === nextProps.filterKey &&
        prevProps.checked === nextProps.checked &&
        prevProps.onToggle === nextProps.onToggle
      );
    }
  );

export default FilterCheckboxItem;